jQuery(function($)
{
    var
        $copyLinkToClipboardTrigger = $('.js-copy-link-to-clipboard-trigger'),
        $copyTokenToClipboardTrigger = $('.js-copy-token-to-clipboard-trigger'),
        $copyApiKeyToClipboardTrigger = $('.js-copy-api-key-to-clipboard-trigger');

    function copyTokenToClipboard(target)
    {
        var $temp = $('<input>');

        $('body').append($temp);
        $temp.val(target.text()).select();
        document.execCommand('copy');
        $temp.remove();
    }

    function copyTokenFeedback(target)
    {
        $(target).removeClass('fa-copy');
        $(target).addClass('fa-check');

        setTimeout(function()
        {
            $(target).removeClass('fa-check');
            $(target).addClass('fa-copy');
        }.bind(target), 3000);
    }

    function copyApiKeyToClipboard(target)
    {
        var $temp = $('<input>');

        $('body').append($temp);
        $temp.val(target.text()).select();
        document.execCommand('copy');
        $temp.remove();
    }

    function copyApiKeyFeedback(target)
    {
        $(target).removeClass('fa-copy');
        $(target).addClass('fa-check');

        setTimeout(function()
        {
            $(target).removeClass('fa-check');
            $(target).addClass('fa-copy');
        }.bind(target), 3000);
    }

    $copyTokenToClipboardTrigger.on('click', function()
    {
        var $copyTokenToClipboardTarget = $('#download-token');

        copyTokenToClipboard($copyTokenToClipboardTarget);
        copyTokenFeedback($(this));
        event.preventDefault();
    });

    $copyLinkToClipboardTrigger.on('click', function()
    {
        var $copyLinkToClipboardTarget = $('#' + $(this).data('target'));

        copyLinkToClipboard($copyLinkToClipboardTarget);
        copyLinkFeedback($(this));
        event.preventDefault();
    });

    $copyApiKeyToClipboardTrigger.on('click', function()
    {
        var $copyApiKeyToClipboardTarget = $(this).closest('.api-key').find('span');

        copyApiKeyToClipboard($copyApiKeyToClipboardTarget);
        copyApiKeyFeedback($(this));
        event.preventDefault();
    });
});

export function copyLinkToClipboard(target)
{
    var $temp = $('<input>');

    $('body').append($temp);
    $temp.val($(target).attr('href') + '?' + 'download_token' + '=' + $('#download-token').text()).select();
    document.execCommand('copy');
    $temp.remove();
}

export function copyLinkFeedback(target)
{
    var $feedbackContainer = $('<span></span>');

    $feedbackContainer.addClass('feedback-container');

    $(target).text($('meta[itemprop=file-link-copy-feedback]').attr('content'));
    $(target).addClass('completed');
    $(target).prepend($feedbackContainer);

    setTimeout(function()
    {
        $(target).find('.feedback-container')
            .remove();
        $(target).removeClass('completed');
        $(target).text($('meta[itemprop=file-link-copy]').attr('content'));
    }.bind(target), 3000);
}
